<template>
  <div>
    <div class="container-fluid mt-base">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-12">
          <vs-select
            :disabled="selectDisabled"
            autocomplete
            :label="$t('selectProduct')"
            v-model="product"
            @change="getVideoInfo"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in selectedProduct"
            />
          </vs-select>
        </div>
      </div>
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6">
          <vs-textarea v-show="videoUrl != ''" v-model="videoUrl" height="100px" />
        </div>
        <div class="col-md-6">
          <vs-textarea v-show="videoIframe != ''" v-model="videoIframe" height="160px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../http/http-helper";

export default {
  props: ["selectedProduct"],
  computed: {
    selectDisabled() {
      if (this.selectedProduct.length == 0) return true;
      return false;
    },
  },
  data() {
    return {
      product: "",
      videoUrl: "",
      videoIframe: "",
    };
  },
  methods: {
    getVideoInfo() {
      http
        .get(`/products/getbyproductid?productId=${this.product}`)
        .then((response) => {
          response.productFiles.forEach((element) => {
            if (element.isVideo == true) {
              this.videoUrl = "https://api.360photoboxcloud.com/" + element.fileName;
              this.videoIframe = `<iframe src="https://api.360photoboxcloud.com/${element.fileName}" width="auto" height="auto" frameborder="0" scrolling="no" style="background-color: #fff; border: 0;" allowfullscreen></iframe>`;
            }
          });
        });
    },
  },
};
</script>

<style scoped>
</style>